import type { ApiClient } from "@/lib/api";
import type { McpSlugCheckRequest, McpSlugCheckResponse } from "../types";

export const checkMcpSlug = async (options: {
  client: ApiClient;
  payload: McpSlugCheckRequest;
}): Promise<McpSlugCheckResponse> => {
  const { client, payload } = options;
  const { data } = await client.post<McpSlugCheckResponse>(
    "/gateways/slug",
    payload
  );
  return data;
};
